import { DOCS_URL } from "../../envVariables";
import { ExternalLink } from "../../newcomponents/table/components/ExternalLink";
import { WorkloadType } from "../../schema/types/workload/entity";

export const DrawerWorkloadOptions = {
  key: `default-options-info`,
  title: "Default Options",
  Content: (workloadType: WorkloadType) => (
    <div>
      <div className="mb-6">
        <div className="mb-2 font-semibold">Capacity AI</div>
        <ul className="flex flex-col gap-1">
          <li className="ml-4" style={{ listStyleType: "disc" }}>
            Dynamically adjusts CPU/memory based on past usage.
          </li>
          <li className="ml-4" style={{ listStyleType: "disc" }}>
            Works within set min/max limits per container.
          </li>
          <li className="ml-4" style={{ listStyleType: "disc" }}>
            Reduces cost, but may briefly underperform on sudden spikes.
          </li>
          <li className="ml-4" style={{ listStyleType: "disc" }}>
            If disabled, uses fixed resource settings.
          </li>
        </ul>
      </div>
      {workloadType === "cron" ? null : (
        <>
          <div className="mb-6">
            <div className="mb-2 font-semibold">Spot</div>
            <div>Uses spot instances to place replicas in.</div>
          </div>
          <div className="mb-6">
            <div className="mb-2 font-semibold">Debug</div>
            <div>
              In order to see detailed routing for the global georouted endpoint of a workload, debug values can be
              included within the response headers of a workload’s endpoint request.
            </div>
            <ExternalLink label="See Docs" url={`${DOCS_URL}/reference/workload/general#debug`} disableCopy />
          </div>
          <div className="mb-6">
            <div className="mb-2 font-semibold">Suspend</div>
            <div>
              Immediately stops the workload from serving traffic. This is the same as setting the min/max scale to 0.
            </div>
          </div>
        </>
      )}
      <div className="mb-6">
        <div className="mb-2 font-semibold">Multizone</div>
        <ul className="flex flex-col gap-1">
          <li className="ml-4" style={{ listStyleType: "disc" }}>
            Dynamically adjusts CPU/memory based on past usage.
          </li>
          <li className="ml-4" style={{ listStyleType: "disc" }}>
            Works within set min/max limits per container.
          </li>
          <li className="ml-4" style={{ listStyleType: "disc" }}>
            Reduces cost, but may briefly underperform on sudden spikes.
          </li>
          <li className="ml-4" style={{ listStyleType: "disc" }}>
            If disabled, uses fixed resource settings.
          </li>
        </ul>
      </div>
      <div className="mb-6">
        <div className="mb-2 font-semibold">Timeout Seconds</div>
        <div>The maximum request duration in seconds before Control Plane will timeout.</div>
      </div>
    </div>
  ),
};
